import {Component, HostBinding, input} from '@angular/core';

@Component({
    selector: 'employee-info-block',
    standalone: true,
    imports: [],
    templateUrl: './info-block.component.html',
    styleUrl: './info-block.component.less'
})
export class InfoBlockComponent {
    blockTitle = input<string>('');
    noTopPadding = input<boolean>(false);
    noBottomBorder = input<boolean>(false);

    @HostBinding('class.no-top-padding')
    get topPadding(): boolean {
        return this.noTopPadding();
    }

    @HostBinding('class.no-bottom-border')
    get bottomBorder(): boolean {
        return this.noBottomBorder();
    }
}
